import ThermostatOutlinedIcon from "@mui/icons-material/ThermostatOutlined";
import TemperatureSheetReport from "./temperatureSheet/TemperatureSheetReport";
import TemperatureSheetFields, { DEFAULT_PARAMS, canBuild, prepareParams } from "./temperatureSheet/TemperatureSheetFields";
import TemperatureSheetPreview from "./temperatureSheet/TemperatureSheetPreview";

// Tipos de reporte del frontend, con la misma clave que Reports::Registry en el backend. Un reporte nuevo es una entrada
// aquí y su carpeta: la página Reportes y las plantillas lo toman sin cambios.
//   Component      → el reporte rápido (local, fechas, vista previa y PDF)
//   Fields         → los campos del reporte sin local ni fechas (los usa el editor de plantillas)
//   Preview        → el reporte en la pantalla, con los datos de la vista previa del backend
//   defaultParams  → parámetros de una plantilla nueva
//   prepareParams  → ajusta los parámetros a las opciones de un local o de la empresa
//   canBuild       → si con esas opciones y parámetros se puede generar
const REPORT_TYPES = {
    temperature_sheet: {
        icon: ThermostatOutlinedIcon, Component: TemperatureSheetReport, Fields: TemperatureSheetFields, Preview: TemperatureSheetPreview,
        defaultParams: DEFAULT_PARAMS, prepareParams, canBuild,
    },
};

export const getReportType = (key) => REPORT_TYPES[key] || null;
